const version = 'exp-logger@1.0.0';

export class ExpLogger {
  constructor(name, activity) {
    this.name = name;
    this.activity = activity;
  }

  /**
   * Log experiment information
   * @param {string} action - user action
   * @param {string} flight - user flight
   * @returns {void}
   */
  log(action, flight) {
    if (!this.activity) return;

    const message = {
      Version: version,
      Experiment: this.name,
      Action: action,
      Flight: flight,
    };

    this.activity.trace(JSON.stringify(message), this.name);
  }
}
